import SaveIcon from "@mui/icons-material/Save";
import Button, { type ButtonProps } from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export function SaveButton({
  loading = false,
  disabled = false,
  onClick,
  children,
  ...rest
}: ButtonProps) {
  const { t } = useTranslation("Fixhub", { keyPrefix: "Next:Core:SaveButton" });
  return (
    <Button
      variant="contained"
      color="primary"
      type="submit"
      loadingPosition="start"
      loading={loading}
      startIcon={<SaveIcon />}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children ?? t("buttonText", "Save")}
    </Button>
  );
}
